/* eslint-disable css-modules/no-unused-class  */
import { FC, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import Gallery from '../gallery';
import ResultCard, { ResultsCardProps } from '../resultsCard/resultsCard';
import styles from './assessmentsResults.module.scss';

const AssessmentsResults: FC<{ assessmentsResults: ResultsCardProps[]; isEmpty: boolean }> = ({
    assessmentsResults,
    isEmpty
}: {
    assessmentsResults: ResultsCardProps[];
    isEmpty: boolean;
}) => {
    const assessmentResultRef = useRef<HTMLDivElement>(null);
    const location = useLocation();

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const result = searchParams.get('result');
        if (Boolean(result) && assessmentResultRef.current) {
            assessmentResultRef.current.scrollIntoView();
        }
    }, [location.search]);

    return (
        <div className={styles['assessments-results-wrapper']} ref={assessmentResultRef}>
            <div className={styles['assessment-section-gallery']}>
                {assessmentsResults.length > 1 ? (
                    <Gallery elementWidth="30rem" numberOfElements={assessmentsResults.length}>
                        {assessmentsResults.map((assessment, i) => (
                            <ResultCard {...assessment} key={i} />
                        ))}
                    </Gallery>
                ) : (
                    !isEmpty && <ResultCard {...assessmentsResults[0]} />
                )}
                {isEmpty && (
                    <ResultCard
                        isEmpty
                        name={''}
                        score={0}
                        totalQuestions={0}
                        correctAnswers={0}
                        startDate={new Date()}
                        endDate={new Date()}
                        answers={[]}
                    ></ResultCard>
                )}
            </div>
        </div>
    );
};

export default AssessmentsResults;
